import * as actions from "./actionsTypes";
import BudgetControlActionsServices from "./budgetControlActions.services";
import toastr from "toastr";
import messages from "../../messages";
import axios from "axios";

export const getBudgets =
  (filters = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: actions.LOADING_BUDGET_ACTIONS, payload: true });
      const response = await BudgetControlActionsServices.getCompaniesBudget(
        filters
      );
      dispatch({
        type: actions.GET_BUDGETS,
        payload: {
          budgets: response.data.data,
          budgetsLength: response.data.count || response.data.length,
        },
      });
    } catch (error) {
      handleError(error, dispatch, actions.BUDGET_ACTIONS_FAIL);
    } finally {
      dispatch({ type: actions.LOADING_BUDGET_ACTIONS, payload: false });
    }
  };

export const createBudget = (data) => async (dispatch) => {
  try {
    dispatch({ type: actions.SAVE_LOADING_BUDGET_ACTIONS, payload: true });
    const response = await BudgetControlActionsServices.createCompanyBudget(
      data
    );
    dispatch({ type: actions.CREATE_BUDGET, payload: response.data });
    await dispatch(getBudgets());
    toastr.success(messages.successMessage);
    return response.data.id;
  } catch (error) {
    handleError(error, dispatch, actions.FORM_FAIL);
  } finally {
    dispatch({ type: actions.SAVE_LOADING_BUDGET_ACTIONS, payload: false });
  }
};

export const deleteBudget = (id) => async (dispatch) => {
  try {
    dispatch({ type: actions.LOADING_BUDGET_ACTIONS, payload: true });
    await BudgetControlActionsServices.deleteCompanyBudget(id);
    dispatch({ type: actions.DELETE_BUDGET, payload: id });
    await dispatch(getBudgets());
    toastr.success(messages.successMessage);
  } catch (error) {
    handleError(error, dispatch, actions.BUDGET_ACTIONS_FAIL);
  } finally {
    dispatch({ type: actions.LOADING_BUDGET_ACTIONS, payload: false });
  }
};

export const getAnnualBudgets =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: actions.LOADING_BUDGET_ACTIONS, payload: true });
      const response = await BudgetControlActionsServices.getAnnualBudget(
        params
      );

      dispatch({
        type: actions.GET_ANNUAL_BUDGETS,
        payload: {
          annualBudgets: response.data || { presupuestos_mensuales: [] },
          annualBudgetsLength:
            response.data?.presupuestos_mensuales?.length || 0,
        },
      });
    } catch (error) {
      handleError(error, dispatch, actions.BUDGET_ACTIONS_FAIL);
    } finally {
      dispatch({ type: actions.LOADING_BUDGET_ACTIONS, payload: false });
    }
  };

export const createAnnualBudget =
  (data, organizationName) => async (dispatch) => {
    try {
      dispatch({ type: actions.SAVE_LOADING_BUDGET_ACTIONS, payload: true });

      const budgetResponse =
        await BudgetControlActionsServices.createAnnualBudget(data);

      await BudgetControlActionsServices.emailSend({
        empleados_codigos: data.responsables,
        presupuesto: {
          organizacion: organizationName,
          año: data.año,
          monto_total: data.monto_total,
          meses: data.meses,
        },
      });

      dispatch({
        type: actions.CREATE_ANNUAL_BUDGET,
        payload: budgetResponse.data,
      });
      toastr.success(messages.successMessage);
      return budgetResponse.data;
    } catch (error) {
      handleError(error, dispatch, actions.FORM_FAIL);
      throw error;
    } finally {
      dispatch({ type: actions.SAVE_LOADING_BUDGET_ACTIONS, payload: false });
    }
  };

export const clearAnnualBudgets = () => ({
  type: actions.CLEAR_ANNUAL_BUDGETS,
});

export const sendBudgetEmail = (data) => async (dispatch) => {
  try {
    dispatch({ type: actions.SEND_EMAIL_LOADING });

    const response = await BudgetControlActionsServices.emailSend(data);

    dispatch({ type: actions.SEND_EMAIL_SUCCESS });
    toastr.success(messages.emailSentSuccess);
    return response.data;
  } catch (error) {
    handleError(error, dispatch, actions.SEND_EMAIL_FAIL);
    throw error;
  }
};

export const updateMonthlyBudgetExpenditure =
  (data, id) => async (dispatch) => {
    dispatch({
      type: actions.UPDATE_MONTHLY_BUDGET_EXPENDITURE_LOADING,
      payload: true,
    });

    try {
      const response =
        await BudgetControlActionsServices.updateMonthlyBudgetExpenditure(
          data,
          id
        );
      dispatch({
        type: actions.UPDATE_MONTHLY_BUDGET_EXPENDITURE,
        payload: response.data,
      });
      toastr.success(messages.successMessage);
    } catch (error) {
      handleError(
        error,
        dispatch,
        actions.UPDATE_MONTHLY_BUDGET_EXPENDITURE_FAIL
      );
    }
  };

const handleError = (error, dispatch, actionType) => {
  let message = null;
  if (axios.isAxiosError(error)) {
    if (error.response?.status) {
      switch (error.response.status) {
        case 400:
          message = error.response.data.error;
          break;
        case 404:
          message = messages.errorMessage + " " + error.response.data.error;
          break;
        case 500:
          message = messages.errorMessage + " " + error.response.data.error;
          break;
        default:
          message = error.response.data;
          break;
      }
    } else {
      message =
        error.message === "Network Error"
          ? messages.networkError
          : error.message;
    }
  } else {
    message =
      error.message === "Network Error" ? messages.networkError : error.message;
  }
  dispatch({ type: actionType, payload: message });
  toastr.error(message);
};
